import MonetaryUtils from "../../../shared/utils/MonetaryUtils";
import { hasValue } from "../../utils/pacto-rebates-utils";

const isPositiveNumber = value => {
	return Number(value) > 0;
};

const isPositiveCurrency = value => {
	return MonetaryUtils.parseCurrency(value) > 0;
};

const isPositiveDecimal = value => {
	return MonetaryUtils.parseDecimal(value) > 0;
};

export const formatPactoRebatesParamsPayload = ({
	baselinePeriod,
	measurementPeriod,
	minimumNetSalesBaselineValue,
	netSalesToGrossSalesConversionIndex,
	gracePeriodPaymentPercentageSum,
	numberOfInstallmentsForCalculationBase,
	installmentsAdjustmentPercentage,
	simulatorDisclaimer
}) => ({
	periodoMesesBaseLine: Number(baselinePeriod),
	periodoMesesApuracao: Number(measurementPeriod),
	valorMinimoBaseLineNetSales: MonetaryUtils.parseCurrency(minimumNetSalesBaselineValue),
	indiceConversaoNetSalesGrossSales: MonetaryUtils.parseDecimal(netSalesToGrossSalesConversionIndex),
	somaPercentualPagamento: MonetaryUtils.parseDecimal(gracePeriodPaymentPercentageSum),
	quantidadePadraoParcelasBaseCalculo: Number(numberOfInstallmentsForCalculationBase),
	percentualReajusteParcelas: MonetaryUtils.parseDecimal(installmentsAdjustmentPercentage),
	disclaimerSimulador: String(simulatorDisclaimer || "").trim()
});

export const formatPactoRebatesParamsResponse = params => ({
	baselinePeriod: params.periodoMesesBaseLine,
	measurementPeriod: params.periodoMesesApuracao,
	minimumNetSalesBaselineValue:
		params.valorMinimoBaselineNetSales ??
		params.valorMinimoBaseLineNetSales,
	netSalesToGrossSalesConversionIndex: params.indiceConversaoNetSalesGrossSales,
	gracePeriodPaymentPercentageSum: params.somaPercentualPagamento,
	numberOfInstallmentsForCalculationBase: params.quantidadePadraoParcelasBaseCalculo,
	installmentsAdjustmentPercentage: params.percentualReajusteParcelas,
	simulatorDisclaimer: params.disclaimerSimulador
});

export const validatePactoRebatesParamsPayload = values => {
	const errors = {};

	if (!hasValue(values.baselinePeriod)) {
		errors.baselinePeriod = "Informe o período em meses da baseline.";
	} else if (!isPositiveNumber(values.baselinePeriod)) {
		errors.baselinePeriod = "O período em meses da baseline deve ser maior que zero.";
	}

	if (!hasValue(values.measurementPeriod)) {
		errors.measurementPeriod = "Informe o período em meses de apuração.";
	} else if (!isPositiveNumber(values.measurementPeriod)) {
		errors.measurementPeriod = "O período em meses de apuração deve ser maior que zero.";
	}

	if (!hasValue(values.minimumNetSalesBaselineValue)) {
		errors.minimumNetSalesBaselineValue = "Informe o valor mínimo da baseline de Net Sales.";
	} else if (!isPositiveCurrency(values.minimumNetSalesBaselineValue)) {
		errors.minimumNetSalesBaselineValue = "O valor mínimo da baseline de Net Sales deve ser maior que zero.";
	}

	if (!hasValue(values.netSalesToGrossSalesConversionIndex)) {
		errors.netSalesToGrossSalesConversionIndex = "Informe o índice de conversão de Net Sales para Gross Sales.";
	} else if (!isPositiveDecimal(values.netSalesToGrossSalesConversionIndex)) {
		errors.netSalesToGrossSalesConversionIndex = "O índice de conversão de Net Sales para Gross Sales deve ser maior que zero.";
	}

	if (!hasValue(values.gracePeriodPaymentPercentageSum)) {
		errors.gracePeriodPaymentPercentageSum = "Informe a soma do percentual de pagamento no período de carência.";
	} else if (!isPositiveDecimal(values.gracePeriodPaymentPercentageSum)) {
		errors.gracePeriodPaymentPercentageSum = "A soma do percentual de pagamento no período de carência deve ser maior que zero.";
	}

	if (!hasValue(values.numberOfInstallmentsForCalculationBase)) {
		errors.numberOfInstallmentsForCalculationBase = "Informe a quantidade de parcelas para base de cálculo.";
	} else if (Number(values.numberOfInstallmentsForCalculationBase) <= 13) {
		errors.numberOfInstallmentsForCalculationBase = "A quantidade de parcelas para base de cálculo deve ser maior que 13.";
	}

	if (!hasValue(values.installmentsAdjustmentPercentage)) {
		errors.installmentsAdjustmentPercentage = "Informe o percentual de reajuste nas parcelas.";
	} else if (!isPositiveDecimal(values.installmentsAdjustmentPercentage)) {
		errors.installmentsAdjustmentPercentage = "O percentual de reajuste nas parcelas deve ser maior que zero.";
	}

	if (!hasValue(String(values.simulatorDisclaimer || "").trim())) {
		errors.simulatorDisclaimer = "Informe o disclaimer do Simulador do Pacto.";
	}

	return errors;
};

export const buildPactoRebatesParamsQuery = ({ fields } = {}) => {
	const params = new URLSearchParams();

	const normalizedFields = Array.isArray(fields)
		? fields.filter(Boolean).join(",")
		: String(fields || "").trim();

	if (normalizedFields) {
		params.set("campos", normalizedFields);
	}

	const queryString = params.toString();

	return queryString ? `?${queryString}` : "";
};
